// Maps the `?error=` code the api appends when GET /auth/verify redirects a failed link back to
// /sign-in, to a human message. Pure (no React) so it is unit-testable in the node test env.
export function signInErrorMessage(code: string | null): string | null {
  switch (code) {
    case null:
    case '':
      return null;
    case 'link_invalid':
      return 'That sign-in link is invalid or has expired. Request a new one below.';
    case 'forbidden':
      return 'Your access to this workspace is no longer active. Contact your administrator.';
    default:
      return 'Something went wrong with that sign-in link. Request a new one below.';
  }
}
